import { gql } from '@apollo/client';
import AddressFragment from "../../fragments/Address";

const getIncomingOrders = gql`
  query GetIncomingOrders($model: IncomingOrderParams) {
    incomingOrdersContext {
      incomingOrders(model: $model) {
        items {
          supplierOrderId
          supplierOrderNo
          comment
          companyOrderno
          costPlaceOrder
          costPlaceOrder2
          costPlaceOrder3
          deliveryDateWish
          deliveryAddress {
            ...AddressFields
          }
          invoiceAddress {
            ...AddressFields
          }
          orderDate
          ordererAddress {
            email
          }
          orderId
          status
          orderStatus
          sumInclVat
          username
          orderingCompany
        }
        totalResult
      }
    }
  }
  ${AddressFragment}
`;

export default getIncomingOrders;
